// export const APP_ROOT_URI = 'http://localhost:3001/api';
export const APP_ROOT_URI = 'https://app.catalandictionary.com/api';

export const AUTH0_CLIENT_ID = 'qtuoXvSMqtQPzwMRL9ZTphtQU2zB1Mjr';
export const AUTH0_DOMAIN = 'https://catalandictionary.eu.auth0.com';
export const AUTH0_AUDIENCE = 'https://app.catalandictionary.com/';
